import { withInstall } from '@tav-ui/utils/with-install'
import IconPicker from './src/icon-picker.vue'
const TaIconPicker = withInstall(IconPicker)
export { TaIconPicker }
export default TaIconPicker
export * from './src/types'
